export const allChallenges: IChallenge[] = [
  {
    id: "win-by-bankruptcy",
    name: "Win by bankrupting all players before the turns end.",
    description:
      "Win through bankruptcy of all players before the turns end. If you are the last player standing, you win. If the game ends before all players are bankrupt, you lose the challenge",
  },
  {
    id: "start-with-1200-money",
    name: "Start with 1200 money",
    description: "You will have 1200M at the start of the game and others will have 1500M. You have win the",
  },
  {
    id: "win-as-rent-lord-without-houses",
    name: "Win a game as Rent Lord without building houses",
    description:
      "Win the game as Rent Lord without building houses. The menu for buying houses will be disabled for this challenge.",
  },

  {
    id: "win-by-6000-networth",
    name: "Win game by networth of 6000M",
    description:
      "Win the game by reaching 6000M networth. If all players are bankrupted before turns end, you lose. You need to take the game to end and win by networth calculation method. And you should have 6000M or more than that",
  },
  {
    id: "win-without-stock-exchange",
    name: "Win a game without using stock exchange",
    description:
      "Win the game without using stock exchange. The menu for stock exchange will be disabled for this challenge.",
  },
  {
    id: "no-negative-money",
    name: "Win a game without having negative money",
    description:
      "If you go to negative money you lose immediately. You need to win the game without going to negative money.",
  },
  {
    id: "always-above-300",
    name: "Win a game without going below 300 money",
    description:
      "If you go below 300 money you lose immediately. You need to win the game without going below 300 money.",
  },
  {
    id: "win-when-opponents-already-own-property",
    name: "Win a game where opponents already own a random property from the start",
    description: "Win the game when opponents already own property and you don't. No other conditions",
  },
  {
    id: "no-round-completion-money",
    name: "Win a game where you never get 200M for round completion",
    description:
      "You will not get 200M for round completion. You need to win the game without getting 200M for round completion. Note if you are financer you will get 100M",
  },
  {
    id: "start-with-1000-money",
    name: "Start with 1000 money",
    description:
      "You will have 1000M at the start of the game and others will have 1500M. You have win the game from here. Note financer will also get 1000M at start not more.",
  },
  {
    id: "win-as-wall-street-wolf-with-investment-over-1000M",
    name: "Win a game as Wall Street Wolf with investment over 1000M",
    description:
      "You have to win the game but you have to invest 1000M or more in the stock exchange. You don't need invest all at once but in overall game.",
  },
  {
    id: "win-as-wall-street-wolf-with-investment-over-2000M",
    name: "Win a game as Wall Street Wolf with investment over 2000M",
    description:
      "You have to win the game but you have to invest 2000M or more in the stock exchange. You don't need invest all at once but in overall game.",
  },
]
